<div class="AmBagsFooterCountBags-content">
  <span class="fs-22px fw-medium">{{count}}</span>
  <span class="opacity-75 am-upper-case">{{labelWeight | translate}}</span>
</div>


